<template>
  <b-modal
    id="modal-force-delivered"
    title="Pesanan Sampai"
    :visible="open"
    :cancel-disabled="isPending"
    :ok-disabled="isPending"
    @hidden="onHidden"
    @shown="onShown"
    @ok="onSubmit"
  >
    <b-card-text>
      Pesanan telah diterima oleh pembeli. Apakah Anda ingin menandai transaksi ini sebagai selesai?
    </b-card-text>
  </b-modal>
</template>

<script>
import {
  BCardText,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  components: {
    BCardText,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    hide: {
      type: Function,
      default: null,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isPending: false,
    }
  },
  methods: {
    ...mapActions('transaction', ['onSubmitDelivered']),
    onHidden() {
      this.hide()
    },
    onShown() {},
    async onSubmit() {
      this.isPending = true
      await this.onSubmitDelivered(this.data.id)
      this.isPending = false
      await this.$emit('callback')
      this.onHidden()
    },
  },
}
</script>
